import { gql } from '@apollo/client';

export default gql`
  query inspectionMonthlyOverview($fromDate: ISO8601Date, $toDate: ISO8601Date) {
    inspectionMonthlyOverview(fromDate: $fromDate, toDate: $toDate) {
      overview {
        month
        pendingInspections
        completedInspections
        canceledInspections
      }
      period {
        from
        to
      }
    }
  }
`;
